export default __webpack_public_path__ + "static/media/binIcon.2ea51ccd.svg";